export default __webpack_public_path__ + "static/media/liberary.8d1c6140.svg";